import './MissionPage.css'
import websiteData from '../../data/websiteData'
import SoftAurora from '../effects/AuroraSoft'

const { mission } = websiteData

export default function MissionPage() {
    return (
        <section className="mission">
            <div className="mission-aurora">
                <SoftAurora
                    color1="#2563EB"
                    color2="#3B82F6"
                    brightness={0.5}
                    noiseAmplitude={2}
                    mouseInfluence={0.1}
                  //  noiseFrequency={3.5}
                />
            </div>
            <div className="mission-inner">
                <div className="mission-header">
                    <span className="mission-eyebrow">Who we are</span>
                    <h1>{mission.title}</h1>
                </div>
                <ol className="mission-list">
                    {mission.items.map((item, i) => (
                        <li key={i} className="mission-item">
                            <span className="mission-number">0{i + 1}</span>
                            <span className="mission-text">{item}</span>
                        </li>
                    ))}
                </ol>
            </div>
        </section>
    );
}